import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import FeedPostSlider from 'src/app/molecules/FeedPostSlider/FeedPostSlider';
import { IStaticContentfulImages } from 'src/types/contentful';

const FeedPosts = (): JSX.Element => {
  const images = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      masterclass: contentfulAsset(contentful_id: { eq: "27FymQpv3Un63CSFuqyvRS" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1800)
      }
      writeHearted: contentfulAsset(contentful_id: { eq: "1GyQNoLv7T08g77wRDzlY9" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1800)
      }
      creativeBoom: contentfulAsset(contentful_id: { eq: "1SMUhBcpgotcIXl9G7qUI5" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1800)
      }
      modernMetalAcademy: contentfulAsset(contentful_id: { eq: "53HFwLl0EFllJdQ6EFPGJe" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1800)
      }
      meetTheTeam: contentfulAsset(contentful_id: { eq: "2KhyLPjdL5wkWsfs1IK1JO" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1800)
      }
    }
  `);

  const posts = [
    {
      href: '/peoplemagic',
      image: {
        image: images.masterclass.gatsbyImageData,
        alt: 'Masterclass',
      },
      imageMaxWidth: 336,
      title: 'Watch the Masterclass',
    },
    {
      href: '/case-studies/the-studio',
      image: {
        image: images.creativeBoom.gatsbyImageData,
        alt: 'Creative Boom',
      },
      imageMaxWidth: 336,
      title: 'Read the Case Study',
    },
    {
      href: '/about',
      image: {
        image: images.meetTheTeam.gatsbyImageData,
        alt: 'Meet the Team',
      },
      imageMaxWidth: 336,
      title: 'Meet the Team',
    },
    {
      href: '/case-studies/write-hearted',
      image: {
        image: images.writeHearted.gatsbyImageData,
        alt: 'Write Hearted',
      },
      imageMaxWidth: 336,
      title: 'Read the Case Study',
    },
    {
      href: '/case-studies/modern-metal-academy',
      image: {
        image: images.modernMetalAcademy.gatsbyImageData,
        alt: 'Modern Metal Academy',
      },
      imageMaxWidth: 336,
      title: 'Read the Case Study',
    },
  ];

  return <FeedPostSlider posts={posts} />;
};

export default FeedPosts;
